// extracted by mini-css-extract-plugin
module.exports = {"video_item":"video_video_item__3hbwC","title":"video_title__1h5OQ","channel":"video_channel__1K-A4","small":"video_small__3NjRW","text_box":"video_text_box__2Kmqg"};